import React from 'react';

function TabContent(props) {
    return (
        <div className="my-3">
            {props.children}
        </div>
    );
}

export default TabContent;